import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { SvgBookings, SvgStar, SvgSuitesAndFacilities } from "@/assets/icons";

import { useEffect, useState } from "react";

const { useBreakpoint } = Grid;

export function ServiceJ1SProvisionInLuxury({ a_provision_in_luxury = {} }) {
	const screens = useBreakpoint();
	const [ref, { isVisible }] = useTrackVisibility();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);
	return (
		<Container ref={ref}>
			<Row justify="center">
				<Col md={24} className={`${visible && "animate__animated animate__fadeInUp"}`}>
					<WrapperContent>
						<RATypography variant={screens?.xs ? "h4" : "h2"} align="center">
							{a_provision_in_luxury?.title || ""}
						</RATypography>
					</WrapperContent>
					<Row justify="center">
						<Col xl={10} lg={12} md={16} sm={20} xs={24}>
							<RATypography
								variant="body3"
								top={screens?.xs ? "10px" : "20px"}
								color="#595959"
								align="center"
							>
								{a_provision_in_luxury?.sub_title || ""}
							</RATypography>
						</Col>
					</Row>
				</Col>
			</Row>
			<WrapperSection>
				<Row gutter={[0, 60]}>
					<Col span={24} className={`${visible && "animate__animated animate__zoomIn"}`}>
						<CardSectionItem
							name={a_provision_in_luxury?.hight_light1?.title || ""}
							description={a_provision_in_luxury?.hight_light1?.description || ""}
							image={
								a_provision_in_luxury?.hight_light1?.photo ||
								PATH_PUBLIC_IMAGES.service_j1s_provision_luxury_1
							}
							icon={<SvgSuitesAndFacilities />}
						/>
					</Col>
					<Col span={24} className={`${visible && "animate__animated animate__zoomIn"}`}>
						<CardSectionItem
							name={a_provision_in_luxury?.hight_light2?.title || ""}
							description={a_provision_in_luxury?.hight_light2?.description || ""}
							image={
								a_provision_in_luxury?.hight_light2?.photo ||
								PATH_PUBLIC_IMAGES.service_j1s_provision_luxury_2
							}
							reverse
							icon={<SvgBookings />}
						/>
					</Col>
					<Col span={24} className={`${visible && "animate__animated animate__zoomIn"}`}>
						<CardSectionItem
							name={a_provision_in_luxury?.hight_light3?.title || ""}
							description={a_provision_in_luxury?.hight_light3?.description || ""}
							image={
								a_provision_in_luxury?.hight_light3?.photo ||
								PATH_PUBLIC_IMAGES.service_j1s_provision_luxury_3
							}
							icon={<SvgStar />}
						/>
					</Col>
				</Row>
			</WrapperSection>
		</Container>
	);
}

const CardSectionItem = ({ name = "", description = "", image, reverse = false, icon }) => {
	const screens = useBreakpoint();
	return (
		<WrapperItem gutter={[0, 20]} align="middle">
			<Col
				sm={{
					span: 12,
					order: reverse ? 2 : 1,
				}}
				xs={{
					span: 24,
					order: 1,
				}}
				style={{
					paddingRight: screens?.xs ? "0" : reverse ? "0" : "40px",
					paddingLeft: screens?.xs ? "0" : reverse ? "40px" : "0",
				}}
			>
				<RAImage
					url={image}
					width="100%"
					height={screens?.xl ? "384px" : screens?.lg ? "320px" : "210px"}
					borderRadius="12px"
				/>
			</Col>
			<Col
				sm={{
					span: 12,
					order: reverse ? 1 : 2,
				}}
				xs={{
					span: 24,
					order: 2,
				}}
			>
				<WrapperValues>
					{icon}
					<RATypography variant="sub-heading2" top="10px">
						{name}
					</RATypography>
					<RATypography variant="body3" top="10px" color="#595959">
						{description}
					</RATypography>
				</WrapperValues>
			</Col>
		</WrapperItem>
	);
};

const Container = styled.div`
	width: 100%;
	height: 100%;
`;

const WrapperContent = styled.div`
	flex-direction: column;
	align-items: center;
`;
const WrapperValues = styled.div`
	@media (max-width: 576px) {
		padding: 0px 20px;
	}
`;
const WrapperSection = styled.div`
	padding: 30px 0px;
	display: flex;
	flex-direction: column;
`;
const WrapperItem = styled(Row)`
	width: 100%;
	height: 100%;
	@media (max-width: 576px) {
		border-radius: 12px;
		background: #fff;
		box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.04);
		padding-bottom: 20px;
	}
`;
